module.exports = __webpack_public_path__ + "img/brasov_background_hero.efbcf33d.png";